const STITCH_TYPES = {
  'k': {
    label: 'Knit',
    description: 'k on RS, p on WS',
    color: '#e3f2fd',
    category: 'Basic',
    symbol: {
      // Empty SVG symbol for knit stitch
      path: '',
      viewBox: '0 0 24 24',
      stroke: 'none',
      strokeWidth: 0,
      fill: 'none'
    },
    width: 1
  },
  'p': {
    label: 'Purl',
    description: 'p on RS, k on WS',
    color: '#e8f5e9',
    category: 'Basic',
    symbol: {
      // Small filled circle for purl stitch, dark grey, slightly smaller
      path: 'M 12,12 m -3,0 a 3,3 0 1,0 6,0 a 3,3 0 1,0 -6,0',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.2,
      fill: '#333'
    },
    width: 1
  },
  'yo': {
    label: 'Yarn Over',
    color: '#fffde7',
    category: 'Basic',
    symbol: {
      // Smaller circle for yarn over
      path: 'M 12,12 m -4,0 a 4,4 0 1,0 8,0 a 4,4 0 1,0 -8,0',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 1
  },
  'k2tog': {
    label: 'K2tog',
    color: '#f3e5f5',
    category: 'Decreases',
    symbol: {
      // Diagonal line for K2tog (now from bottom left to top right)
      path: 'M 2,22 L 22,2',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 1
  },
  'ssk': {
    label: 'SSK',
    color: '#f3e5f5',
    category: 'Decreases',
    symbol: {
      // Diagonal line for SSK (now from top left to bottom right)
      path: 'M 2,2 L 22,22',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 1
  },
  'p2tog': {
    label: 'P2tog',
    color: '#e8f5e9',
    category: 'Decreases',
    symbol: {
      // Line from bottom left to top right, small dot above the line on the left
      path: 'M 2,22 L 22,2 M 6,6 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 1
  },
  'ssp': {
    label: 'SSP',
    color: '#e8f5e9',
    category: 'Decreases',
    symbol: {
      // Mirror of p2tog: line from bottom right to top left, dot above the line on the right
      path: 'M 22,22 L 2,2 M 18,6 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 1
  },
  'blank': {
    label: 'No Stitch',
    color: '#f5f5f5',
    category: 'Special',
    symbol: null,
    isBlank: true
  },
  'k3tog': {
    label: 'K3tog',
    color: '#f3e5f5',
    category: 'Decreases',
    symbol: {
      // Main diagonal matches k2tog (bottom left to top right), plus vertical and center-to-bottom-right strokes
      path: 'M 2,22 L 22,2 M 12,12 L 12,22 M 12,12 L 22,22',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 1
  },
  'sk2p': {
    label: 'Sk2p',
    color: '#f3e5f5',
    category: 'Decreases',
    symbol: {
      // Mirror of k3tog: main diagonal from top left to bottom right, plus vertical and center-to-bottom-left strokes
      path: 'M 22,22 L 2,2 M 12,12 L 12,22 M 12,12 L 2,22',
      viewBox: '0 0 24 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 1
  },
  '2/2 RC': {
    label: '2/2 RC',
    color: '#fff3e0',
    category: 'Cables',
    symbol: {
      path: 'M 0,24 L 48,0 M 48,24 L 96,0 M 0,0 L 24,12 M 72, 12 L 96, 24',
      viewBox: '0 0 96 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 4
  },
  '2/2 LC': {
    label: '2/2 LC',
    color: '#fff3e0',
    category: 'Cables',
    symbol: {
      path: 'M 96,24 L 48,0 M 48,24 L 0,0 M 0,24 L 24,12 M 96, 0 L 72, 12',
      viewBox: '0 0 96 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 4
  },
  '1/1 LC': {
    label: '1/1 LC',
    color: '#ffe0b2',
    category: 'Cables',
    symbol: {
      // Two parallel lines, one in each cell, from bottom right to top left. Half lines as described.
      path: 'M 24,24 L 0,0 M 48,24 L 24,0 M 0,24 L 12,12 M 36,12 L 48,0',
      viewBox: '0 0 48 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 2
  },
  '1/1 RC': {
    label: '1/1 RC',
    color: '#ffe0b2',
    category: 'Cables',
    symbol: {
      // Mirror of 1/1 LC: two parallel lines, one in each cell, from bottom left to top right. Half lines as described.
      path: 'M 0,24 L 24,0 M 24,24 L 48,0 M 48,24 L 36,12 M 12,12 L 0,0',
      viewBox: '0 0 48 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 2
  },
  '2/1 RPC': {
    label: '2/1 RPC',
    color: '#333',
    category: 'Cables',
    symbol: {
      path: 'M 0,24 L 24,0 M 48,24 L 72,0 M 54,18 L 72,24 M 7,6 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 72 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 3
  },
  '2/1 LPC': {
    label: '2/1 LPC',
    color: '#333',
    category: 'Cables',
    symbol: {
      path: 'M 72,24 L 48,0 M 24,24 L 0,0 M 65,6 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0 M 18,18 L 0,24',
      viewBox: '0 0 72 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 3
  },
  '2/2 LPC': {
    label: '2/2 LPC',
    color: '#333',
    category: 'Cables',
    symbol: {
      path: 'M 96,24 L 48,0 M 48,24 L 0,0 M 0,24 L 24,12 M 84,10 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 96 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 4
  },
  '2/2 RPC': {
    label: '2/2 RPC',
    color: '#333',
    category: 'Cables',
    symbol: {
      path: 'M 0,24 L 48,0 M 48,24 L 96,0 M 96,24 L 72,12 M 12,10 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 96 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 4
  },
  '2/3 LC': {
    label: '2/3 LC',
    color: '#333',
    category: 'Cables',
    symbol: {
      // 2/3 Left Cross: both main lines top left to bottom right, half lines opposite direction
      path: 'M 48,0 L 120,24 M 0,0 L 72,24 M 0,24 L 32,12 M 120,0 L 88,12',
      viewBox: '0 0 120 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 5
  },
  '2/3 LPC': {
    label: '2/3 LPC',
    color: '#333',
    category: 'Cables',
    symbol: {
      // 2/3 Left Purl Cross: like 2/3 LC but with 3 dots above the line, shifted further right
      path: 'M 48,0 L 120,24 M 0,0 L 72,24 M 0,24 L 32,12 M 88,7 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0 M 100,7 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0 M 112,7 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 120 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 5
  },
  '2/3 RC': {
    label: '2/3 RC',
    color: '#333',
    category: 'Cables',
    symbol: {
      // 2/3 Right Cross: mirror of 2/3 LC
      path: 'M 72,0 L 0,24 M 120,0 L 48,24 M 120,24 L 88,12 M 0,0 L 32,12',
      viewBox: '0 0 120 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: 'none'
    },
    width: 5
  },
  '2/3 RPC': {
    label: '2/3 RPC',
    color: '#333',
    category: 'Cables',
    symbol: {
      // 2/3 Right Purl Cross: mirror of 2/3 LPC, 3 dots in first 3 cells, shifted to match LPC
      path: 'M 72,0 L 0,24 M 120,0 L 48,24 M 120,24 L 88,12 M 8,7 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0 M 20,7 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0 M 32,7 m -2,0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0',
      viewBox: '0 0 120 24',
      stroke: '#333',
      strokeWidth: 1.5,
      fill: '#333'
    },
    width: 5
  }
};

export default STITCH_TYPES;
